<template>
  <div>
    <div>
      <v-tabs
        v-model="viewTap"
        color="white"
        :slider-color="$vuetify.theme.primary"
        @input="clickTap"
        style="font-size: 18px"
      >
        <v-tab style="text-transform: capitalize;" ripple :href="`#${menuItem[0].view}`"
          >{{ menuItem[0].text }}
        </v-tab>
        
        <v-tab style="text-transform: capitalize" ripple :href="`#${menuItem[1].view}`">{{
          menuItem[1].text
        }}</v-tab>
      

        <v-tab style="text-transform: capitalize" ripple :href="`#${menuItem[2].view}`">{{
          menuItem[2].text
        }}</v-tab>
        
      </v-tabs>

      <v-layout row justify-end class="mt-4">
        <v-flex xs12>
          <InputSearch
            class="mb-3"
            @clickAdvancedSearch="showSearchAdvanced = true"
            @clickSearch="onSearch"
            @clearSearch="
              clearSearch()
              isSearch = false
            "
            :search="filter"
            :placeholder="'ค้นหา Tech Provider, ชื่อสินค้า, รายละเอียด, ลิขสิทธิ์'"
            :isSearch="isSearch"
            :clearAdvancedSearch="clearAdvancedSearch"
            showClearAdvancedSearch
            showAdvancedSearch
          />
        </v-flex>
      </v-layout>

      <v-flex xs12>
        <div style="display: flex; align-items: center">
          <v-flex>
            <Typography h2 bold :label="$t('approved skill by depa')" />
          </v-flex>
          <v-btn
            variant="outlined"
            :v-tooltip="$t('export')"
            @click="exportData"
            :loading="loading"
            icon
            color="#BECCDB"
            style="border-radius: 50% !important"
          >
            <img
              src="/static/img/exportfilter.png"
              alt
              class="responsive-img"
              style="height: 16px"
            />
          </v-btn>
          <exportxlsx ref="exbtn" :value="exData" style="display: none"></exportxlsx>
          <v-btn
            variant="outlined"
            v-tooltip="'เลือกคอลัมน์'"
            icon
            :loading="loading"
            :color="drawer ? '#0C2F53' : '#BECCDB'"
            @click.stop="drawer = !drawer"
            style="border-radius: 50% !important"
          >
            <img
              :src="`/static/img/${drawer ? 'filterColumnWhite.png' : 'filterColumnBlack.png'}`"
              alt
              class="responsive-img"
              style="height: 20px"
            />
          </v-btn>
        </div>
      </v-flex>

      <v-navigation-drawer v-model="drawer" right fixed temporary style="top: 200px; padding: 20px">
        <v-list density="compact" nav>
          <v-flex xs12 style="display: flex; align-items: center; justify-content: space-between">
            <!-- <div class="color-darkBlue bold7 fs-20">เลือกคอลัมน์</div> -->
            <Typography h3 bold label="เลือกคอลัมน์" />
            <v-icon @click.stop="drawer = false">close</v-icon>
          </v-flex>
          <div style="display: flex">
            <v-flex xs10 class="mb-2 mt-2">
              <div
                style="width: 100%; display: flex; align-items: center"
                class="form-group has-search"
              >
                <div
                  style="width: 100%; display: flex; justify-content: flex-end; border-right: 0px"
                  class="form-control"
                >
                  <input
                    @change="changeSearchColumn"
                    type="search"
                    class="depainput rsu mb-0"
                    placeholder="Search"
                    name="search"
                    v-model="searchColumn"
                    style="border-radius: 0px; border-right: 0px"
                  />
                </div>
              </div>
            </v-flex>
            <v-flex xs2 class="mb-2 mt-2">
              <div
                class="pointer"
                style="
                  border: 1px solid #cfcfcf;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-left: 0px;
                  border-right: 0px;
                  border-top-color: initial !important;
                  border-bottom-color: initial !important;
                "
              >
                <span
                  class="fa fa-times-circle form-control-feedback pointer"
                  style="color: #00000040"
                  @click="clearSearchColumn"
                ></span>
              </div>
            </v-flex>
            <v-flex xs2 class="mb-2 mt-2">
              <div
                class="pointer"
                style="
                  border: 1px solid #cfcfcf;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-top-color: initial !important;
                  border-bottom-color: initial !important;
                "
              >
                <span
                  @click="changeSearchColumn"
                  class="fa fa-search form-control-feedback"
                  style="color: #bdbdbd"
                ></span>
              </div>
            </v-flex>
          </div>
          <div style="overflow: auto; height: 380px">
            <div
              class="mt-2"
              style="display: flex"
              v-for="item in this.column"
              @click="clickShowColumn(item)"
              :key="item"
            >
              <v-checkbox
                color="#0C2F53"
                style="display: flex; flex: none !important; margin-top: 0px; padding-top: 0px"
                v-model="showColumn.includes(item)"
                hide-details
                dense
              >
              </v-checkbox>
              <Typography h5 :label="item" />
            </div>
          </div>
        </v-list>
      </v-navigation-drawer>

      <!-- <v-layout row wrap dense class="ma-0">
        <v-flex xs6>
          <div class="headline primary--text">{{ $t('approved by depa') }}</div>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-end class="text-xs-right">
        <v-flex xs6 sm4 class="pr-1">
          <div class="depainput form-control mb-3" style="position: relative">
            <input @keyup="search(1)" v-model="filter.text" style="padding-right: 47px !important" type="text" />
            <v-btn style="position: absolute; right: 0px; top: 0px" icon @click="search(1)"><v-icon
                color="primary">search</v-icon></v-btn>
          </div>
        </v-flex>
        <v-flex xs6 sm4 class="pr-1">
          <multiselect v-model="filter.campaign" :options="campaign" label="campaignname" @input="search(1)" selectLabel
            selectedLabel placeholder="campaign" :allow-empty="false" :searchable="false" deselect-label></multiselect>
        </v-flex>
        <v-flex xs6 sm4 class="pr-1">
          <multiselect :options="category" v-model="filter.category" label="categoryname" @input="search(1)" selectLabel
            selectedLabel placeholder="category" :allow-empty="false" :searchable="false" deselect-label></multiselect>
        </v-flex>
        <v-flex>
          <v-btn color="#152d53" @click="clearFilter" style="color: white; text-transform: capitalize"
            class="px-4">Clear</v-btn>
          <v-btn @click="exportData" :loading="loading" color="grey" outline>
            <i class="fas fa-file-export"></i>
            &nbsp;
            {{ $t('export') }}&nbsp;
          </v-btn>
          <exportxlsx :value="exData" style="display:none" ref="exbtn"></exportxlsx>
        </v-flex>
      </v-layout> -->

      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <v-data-table
        v-else
        :loading="loading"
        :headers="headers"
        :items="showData"
        hide-actions
        item-key="name"
        show-select
        :class="viewTap === 'pending' ? 'fixTable' : 'elevation-1'"
      >
        <template v-slot:headers="props">
          <tr style="background-color: #152d53; color: white">
            <!-- <th class="pl-0 pr-0"></th>
            <th class="pl-0 pr-0"></th> -->
            <!-- <th style="background-color: #152d53; color: yellow" v-for="header in props.headers" :key="header.text">
              {{ header.text }}
            </th> -->

            <th
              style="background-color: #152d53; color: yellow"
              v-for="header in props.headers"
              v-show="showColumn.includes(header.text) || header.text == ''"
              :key="header.text"
            >
              <div v-show="showColumn.includes(header.text)">{{ header.text }}</div>
            </th>
            <th style="background-color: #152d53; color: yellow" v-if="viewTap === 'approve'">
              <div>{{ 'วันที่อนุมัติ' }}</div>
            </th>
            <th style="background-color: #152d53; color: yellow" v-if="viewTap === 'approve'">
              <div>{{ 'อนุมัติโดย' }}</div>
            </th>
            <th style="background-color: #152d53; color: yellow" v-if="viewTap === 'reject'">
              <div>{{ 'วันที่ปฏิเสธ ' }}</div>
            </th>
            <th style="background-color: #152d53; color: yellow" v-if="viewTap === 'reject'">
              <div>{{ 'ผู้ปฏิเสธ' }}</div>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr class="py-3 depatable">
            <td
              class="text-xs-left"
              v-show="showColumn.includes('วันที่')"
              @click.stop="clickShowLog(props.item.productid)"
            >
              <Typography
                style="width: 120px"
                left
                h5
                :label="shotDate(props.item.timestamp) || '-'"
              />
            </td>
            <td
              class="text-xs-left"
              v-show="showColumn.includes('Tech Provider')"
              @click.stop="clickShowLog(props.item.productid)"
            >
              <Typography
                style="width: 200px"
                left
                h5
                :label="props.item.techprovidername || '-'"
              />
            </td>
            <td
              class="text-xs-left"
              v-show="showColumn.includes('ชื่อหลักสูตร')"
              @click.stop="clickShowLog(props.item.productid)"
            >
              <Typography style="width: 200px" left h5 :label="props.item.productname || '-'" />
            </td>
            <td
              class="text-xs-left"
              v-show="showColumn.includes('ราคา')"
              @click.stop="clickShowLog(props.item.productid)"
            >
              <Typography left h5 :label="props.item.price || '-'" />
            </td>
            <td
              class="text-xs-left"
              v-show="showColumn.includes('รายละเอียด')"
              @click.stop="clickShowLog(props.item.productid)"
            >
              <Typography style="width: 240px" left h5 :label="props.item.description || '-'" />
            </td>
            <td
              class="text-xs-left"
              v-show="showColumn.includes('เรทติ้ง')"
              @click.stop="clickShowLog(props.item.productid)"
            >
              <Typography left h5 :label="props.item.score || '-'" />
            </td>
            <td
              class="text-xs-left"
              v-show="showColumn.includes('ประเภทธุรกิจ')"
              @click.stop="clickShowLog(props.item.productid)"
            >
              <Typography style="width: 200px" left h5 :label="props.item.typename || '-'" />
            </td>
            <td
              class="text-xs-left"
              v-show="showColumn.includes('หมวดหมู่')"
              @click.stop="clickShowLog(props.item.productid)"
            >
              <Typography style="width: 240px" left h5 :label="props.item.categoryname || '-'" />
            </td>
            <td
              class="text-xs-left"
              v-show="showColumn.includes('ลิขสิทธิ์')"
              @click.stop="clickShowLog(props.item.productid)"
            >
              <Typography style="width: 200px" left h5 :label="props.item.copyrighttype || '-'" />
            </td>
            <td
              class="text-xs-left"
              v-show="showColumn.includes('Agent')"
              @click.stop="clickShowLog(props.item.productid)"
            >
              {{ props.item.agent || '-' }}
            </td>
            <td class="text-xs-left">
              <!-- <span style="color: blue" @click="clickDetail(props.item.productid)"
                class="text-decoration-underline cursor-5">Details</span> -->
              <div
                style="text-decoration: underline; color: #26588b"
                class="cursor-5"
                @click="clickDetail(props.item.productid)"
              >
                ดูข้อมูล
              </div>
            </td>
            <!-- <td class="text-xs-left">
              <div
                style="text-decoration: underline; color: #26588b"
                class="cursor-5"
                @click.stop="clickUpdate(props.item.productid)"
              >
                Click
              </div>
            </td> -->
            <td
              @click.stop="clickShowLog(props.item.productid)"
              v-if="viewTap === 'approve'"
              class="text-xs-left"
            >
              {{ shotDate(props.item.approveat) || '-' }}
            </td>
            <td
              @click.stop="clickShowLog(props.item.productid)"
              v-if="viewTap === 'approve'"
              class="text-xs-left"
            >
              {{ props.item.approveby || '-' }}
            </td>
            <td
              @click.stop="clickShowLog(props.item.productid)"
              v-if="viewTap === 'reject'"
              class="text-xs-left"
            >
              {{ shotDate(props.item.rejectat) || '-' }}
            </td>
            <td
              @click.stop="clickShowLog(props.item.productid)"
              v-if="viewTap === 'reject'"
              class="text-xs-left"
            >
              {{ props.item.rejectby || '-' }}
            </td>
            <td class="pl-0 pr-0" v-if="viewTap === 'pending'">
              <div style="display:flex;justify-content: space-between;width: 45px;">
                <img
                  @click="
                    modalApprove = true
                    modalID = props.index
                  "
                  src="/static/img/success.png"
                  alt
                  class="cursor-5"
                  style="height: 20px"
                />
                <img
                  @click="
                    modalReject = true
                    modalID = props.index
                  "
                  src="/static/img/error.png"
                  alt
                  class="cursor-5"
                  style="height: 20px"
                />
              </div>
              <!-- <v-btn @click="clickCheckBox(props.index)" icon outline>
                <i :color="$vuetify.theme.primary" class="fas fa-check"></i>
              </v-btn>
              <v-btn @click="clickRejectCheckBox(props.index)" icon outline>
                <i :color="$vuetify.theme.primary" class="fas fa-times"></i>
              </v-btn> -->
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog
        v-model="showLog"
        scrollable
        persistent
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card class="pb-10">
          <div class="text-xs-right">
            <v-spacer></v-spacer>
            <v-btn flat icon small fab @click="showLog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <div class="headline primary--text mt-0 mb-4 ml-3">ประวัติการทำรายการ</div>
          <div v-if="loadLog"></div>
          <div v-else-if="logData && logData.length" class="ml-3 mr-3 mb-4">
            <!-- <div v-for="(item, index) in logData" :key="`log-${index}`">
              {{ item.id }}
            </div> -->
            <v-data-table
              hide-actions
              :headers="headersLog"
              :items="logData"
              select-all
              item-key="name"
              class="elevation-1"
            >
              <template v-slot:headers="props">
                <tr style="background-color: #152d53; color: white">
                  <th
                    style="background-color: #152d53; color: yellow; text-align: center"
                    v-for="(header, k) in props.headers"
                    :key="header.text + k"
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr class="py-3 depatable">
                  <td class="text-xs-center">
                    {{ props.item.adminid }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.status }}
                  </td>
                  <td class="text-xs-center">
                    {{ fullDateTime(props.item.timestamp) }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <h4 class="mb-5 mt-4 text-xs-center" v-else>
            ไม่มีข้อมูล
          </h4>
        </v-card>
      </v-dialog>

      <v-dialog v-model="modalApprove" persistent width="400px">
        <v-card style="border-radius: 10px">
          <div class="pa-4">
            <v-icon style="display: flex;justify-content: end" @click="modalApprove = false"
              >close</v-icon
            >
            <div>
              <Typography center h2 bold label="อนุมัติ" />
            </div>
            <div class="rsu mt-2">
              <v-layout wrap class="mb-3">
                <v-flex xs12>
                  <Typography center h5 label="คุณแน่ใจหรือไม่ว่าต้องการอนุมัติคำขอนี้" />
                </v-flex>
              </v-layout>
              <div style="display: flex; justify-content: center">
                <Button
                  :loading="loading"
                  outline
                  :label="$t('cancel')"
                  @click="modalApprove = false"
                />
                <Button
                  :loading="loading"
                  depressed
                  :label="$t('approved')"
                  @click="clickCheckBox()"
                />
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="modalReject" persistent width="400px">
        <v-card v-if="modalReject" style="border-radius: 10px">
          <div class="pa-4">
            <v-icon style="display: flex;justify-content: end" @click="modalReject = false"
              >close</v-icon
            >
            <div>
              <Typography center h2 bold label="ไม่อนุมัติ" />
            </div>
            <div class="rsu mt-2">
              <v-layout wrap class="mb-2">
                <v-flex xs12>
                  <Typography h5 label="กรุณาใส่เหตุผลที่ไม่อนุมัติคำขอนี้" />
                  <div
                    class="form-control"
                    :class="{ 'has-error': errors.has('เหตุผลที่ไม่อนุมัติคำขอนี้') }"
                  >
                    <textarea
                      v-model="inputReject"
                      type="text"
                      name="เหตุผลที่ไม่อนุมัติคำขอนี้"
                      style="padding: 5px 10px !important;height: 100px !important;"
                      v-validate="'required'"
                    />
                    <p class="text-error" v-if="errors.has('เหตุผลที่ไม่อนุมัติคำขอนี้')">
                      {{ errors.first('เหตุผลที่ไม่อนุมัติคำขอนี้') }}
                    </p>
                  </div>
                </v-flex>
              </v-layout>
              <div style="display: flex; justify-content: center">
                <Button
                  :loading="loading"
                  outline
                  :label="$t('cancel')"
                  @click="modalReject = false"
                />
                <Button
                  :loading="loading"
                  depressed
                  :label="$t('approved')"
                  @click="clickRejectCheckBox()"
                />
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showSearchAdvanced" width="500px" persistent>
        <v-card style="border-radius: 10px">
          <v-btn style="float: right" @click="showSearchAdvanced = false" icon
            ><v-icon>close</v-icon></v-btn
          >
          <div class="pa-4">
            <div style="display: flex">
              <i
                class="fa fa-filter color-darkBlue"
                style="font-size: 18px; display: flex; align-items: center"
                aria-hidden="true"
              ></i>
              <Typography h3 semiBold label="Advanced Search" class="pl-1" />
            </div>
            <div class="rsu">
              <v-layout row wrap>
                <v-flex xs12 class="mb-2 mt-2 pr-1">
                  <Typography class="pr-3" h5 label="แคมเปญ" />
                  <multiselect
                    v-model="filter.campaign"
                    :options="campaign"
                    label="campaignname"
                    selectLabel
                    selectedLabel
                    placeholder="แคมเปญ"
                    :allow-empty="false"
                    :searchable="false"
                    deselect-label
                  >
                  </multiselect>
                </v-flex>
                <v-flex xs12 class="mb-2 mt-2 pr-1">
                  <Typography class="pr-3" h5 label="ประเภทธุรกิจ" />
                  <multiselect
                    :options="typeList.map(val => val.typeid)"
                    v-model="filter.type"
                    :custom-label="customLabel"
                    @input="
                      {
                        getCategory(), (filter.category = null)
                      }
                    "
                    placeholder="ประเภทธุรกิจ"
                    deselect-label
                  ></multiselect>
                </v-flex>
                <v-flex xs12 class="mb-2 mt-2 pr-1">
                  <Typography class="pr-3" h5 label="หมวดหมู่" />
                  <multiselect
                    :options="category"
                    v-model="filter.category"
                    label="categoryname"
                    selectLabel
                    selectedLabel
                    placeholder="หมวดหมู่"
                    :allow-empty="false"
                    :searchable="false"
                    deselect-label
                  >
                  </multiselect>
                </v-flex>
              </v-layout>
              <div class="pt-2" style="display: flex; justify-content: center">
                <Button
                  :loading="searchloading"
                  outline
                  :label="$t('Clear Search')"
                  @click="
                    clearSearch()
                    isSearch = false
                  "
                />
                <Button
                  :loading="searchloading"
                  depressed
                  :label="$t('Search')"
                  @click="onSearch"
                />
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <!-- <v-dialog v-model="modalQualification" persistent width="400px">
        <v-card v-if="modalQualification" style="border-radius: 10px">
          <div class="pa-4">
            <v-icon style="display: flex;justify-content: end" @click="modalQualification = false"
              >close</v-icon
            >
            <div>
              <Typography center h2 bold label="ข้อจำกัด" />
            </div>
            <div class="rsu mt-2">
              <v-layout wrap class="mb-2">
                <v-flex xs12>
                  <Typography h5 label="กรุณาใส่ข้อจำกัด" />
                  <div
                    class="form-control"
                    :class="{ 'has-error': errors.has('ข้อจำกัด') }"
                  >
                    <textarea
                      v-model="inputQualification"
                      type="text"
                      name="ข้อจำกัด"
                      style="padding: 5px 10px !important;height: 100px !important;"
                      v-validate="'required'"
                    />
                    <p class="text-error" v-if="errors.has('ข้อจำกัด')">
                      {{ errors.first('ข้อจำกัด') }}
                    </p>
                  </div>
                </v-flex>
              </v-layout>
              <div style="display: flex; justify-content: center">
                <Button
                  :loading="loading"
                  outline
                  :label="$t('cancel')"
                  @click="modalQualification = false"
                />
                <Button
                  :loading="loading"
                  depressed
                  :label="$t('approved')"
                  @click="updateQualification(productid)"
                />
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog> -->

      <Paginations
        @clickPagination="changepage"
        @sortPage="sortPage"
        :pageCount="pageCount"
        :numberPage="numberPage"
        :page="page"
      />
      <!-- <v-pagination v-if="pageCount" @input="changepage" v-model="page" :length="pageCount"></v-pagination> -->
    </div>
  </div>
</template>

<script>
import api from '@/api'
import Multiselect from 'vue-multiselect'
import Exportxlsx from '@/components/elements/exportxlsx'
import config from '@/config'
import _ from 'lodash'
import moment from 'moment'
import InputSearch from '@/components/elements/InputSearch.vue'
import Typography from '@/components/elements/Typography.vue'
import Button from '@/components/elements/Button.vue'
import Paginations from '@/components/elements/Paginations.vue'

export default {
  components: {
    Multiselect,
    Exportxlsx,
    InputSearch,
    Typography,
    Button,
    Paginations
  },
  watch: {},
  data() {
    return {
      menuItem: [
        {
          text: 'รอตรวจสอบ',
          view: 'pending'
        },
        {
          text: 'อนุมัติ',
          view: 'approve'
        },
        {
          text: 'ปฏิเสธ',
          view: 'reject'
        }
      ],
      countAllProductSkill: 0,
      headers: [],
      baseHeader: [
        // { text: 'Approve', align: 'center', value: 'approve' },
        { text: 'วันที่', align: 'center', value: 'DATE' },
        { text: 'Tech Provider', align: 'center', value: 'techprovider' },
        { text: 'ชื่อหลักสูตร', align: 'center', value: 'product' },
        { text: 'ราคา', align: 'center', value: 'price' },
        { text: 'รายละเอียด', align: 'center', value: 'detail' },
        { text: 'เรทติ้ง', align: 'center', value: 'rating' },
        { text: 'ประเภทธุรกิจ', align: 'center', value: 'type' },
        { text: 'หมวดหมู่', align: 'center', value: 'category' },
        { text: 'ลิขสิทธิ์', align: 'center', value: 'copyright' },
        { text: 'Agent', align: 'center', value: 'agent' },
        { text: 'ดูรายละเอียด', align: 'center', value: 'detail' },
        // { text: 'ข้อจำกัด', align: 'center', value: 'qualification' },
        { text: '', align: 'center', value: '' }
      ],
      headersLog: [
        { text: 'Admin', align: 'center', value: 'admin' },
        { text: 'Status', align: 'center', value: 'status' },
        { text: 'Date', align: 'center', value: 'date' }
      ],
      fullHeader: [
        // { text: 'Approve', align: 'center', value: 'approve' },
        { text: 'วันที่', align: 'center', value: 'DATE' },
        { text: 'Tech Provider', align: 'center', value: 'techprovider' },
        { text: 'ชื่อหลักสูตร', align: 'center', value: 'product' },
        { text: 'ราคา', align: 'center', value: 'price' },
        { text: 'รายละเอียด', align: 'center', value: 'detail' },
        { text: 'เรทติ้ง', align: 'center', value: 'rating' },
        { text: 'ประเภทธุรกิจ', align: 'center', value: 'type' },
        { text: 'หมวดหมู่', align: 'center', value: 'category' },
        { text: 'ลิขสิทธิ์', align: 'center', value: 'copyright' },
        { text: 'Agent', align: 'center', value: 'agent' },
        { text: 'ดูรายละเอียด', align: 'center', value: 'detail' },
        // { text: 'ข้อจำกัด', align: 'center', value: 'qualification' },
        { text: 'วันที่อนุมัติ', align: 'center', value: 'detail' },
        { text: 'อนุมัติโดย', align: 'center', value: 'agent' }
      ],
      fullHeaderReject: [
        // { text: 'Approve', align: 'center', value: 'approve' },
        { text: 'วันที่', align: 'center', value: 'DATE' },
        { text: 'Tech Provider', align: 'center', value: 'techprovider' },
        { text: 'ชื่อหลักสูตร', align: 'center', value: 'product' },
        { text: 'ราคา', align: 'center', value: 'price' },
        { text: 'รายละเอียด', align: 'center', value: 'detail' },
        { text: 'เรทติ้ง', align: 'center', value: 'rating' },
        { text: 'ประเภทธุรกิจ', align: 'center', value: 'type' },
        { text: 'หมวดหมู่', align: 'center', value: 'category' },
        { text: 'ลิขสิทธิ์', align: 'center', value: 'copyright' },
        { text: 'Agent', align: 'center', value: 'agent' },
        { text: 'ดูรายละเอียด', align: 'center', value: 'detail' },
        // { text: 'ข้อจำกัด', align: 'center', value: 'qualification' },
        { text: 'วันที่ปฏิเสธ', align: 'center', value: 'detail' },
        { text: 'ผู้ปฏิเสธ', align: 'center', value: 'agent' }
      ],
      searchColumn: '',
      drawer: false,
      columnAll: [
        'วันที่',
        'Tech Provider',
        'ชื่อหลักสูตร',
        'ราคา',
        'รายละเอียด',
        'เรทติ้ง',
        'ประเภทธุรกิจ',
        'หมวดหมู่',
        'ลิขสิทธิ์',
        'Agent',
        'ดูรายละเอียด'
        // 'ข้อจำกัด'
      ],
      showColumn: [
        'วันที่',
        'Tech Provider',
        'ชื่อหลักสูตร',
        'ราคา',
        'รายละเอียด',
        'เรทติ้ง',
        'ประเภทธุรกิจ',
        'หมวดหมู่',
        'ลิขสิทธิ์',
        'Agent',
        'ดูรายละเอียด'
        // 'ข้อจำกัด'
      ],
      column: [
        'วันที่',
        'Tech Provider',
        'ชื่อหลักสูตร',
        'ราคา',
        'รายละเอียด',
        'เรทติ้ง',
        'ประเภทธุรกิจ',
        'หมวดหมู่',
        'ลิขสิทธิ์',
        'Agent',
        'ดูรายละเอียด'
        // 'ข้อจำกัด'
      ],
      viewTap: 'pending',
      showFilter: false,
      pagination: {
        descending: false,
        sortBy: 'name'
      },
      showSearchAdvanced: false,
      clearAdvancedSearch: false,
      modalApprove: false,
      inputReject: null,
      modalReject: false,
      modalQualification: false,
      inputQualification: null,
      modalID: null,
      showLog: false,
      loadLog: false,
      logData: [],
      filter: {
        nameAll: '',
        campaign: null,
        type: null,
        category: null,
        techprovider: null
      },
      campaign: [],
      category: [],
      showData: [],
      fillStatusData: [],
      data: [],
      exData: [],
      page: 1,
      total: 0,
      rowsPerPage: 15,
      typeList: [],
      loading: false,
      isSearch: false,
      numberPage: {
        page: undefined
      },
    }
  },
  watch: {
    showData: {
      immediate: true,
      handler(showData) {
        if (showData && showData.length) {
          this.setEx()
        }
      }
    },
    viewTap: {
      handler() {
        this.page = 1
        this.getProductSkill()
      }
    }
  },
  computed: {
    pageCount() {
      if (this.total) {
        let count = Math.ceil(this.total / this.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.rowsPerPage - this.rowsPerPage : this.rowsPerPage
    },
    body() {
      return {
        productname: this.filter.nameAll ? this.filter.nameAll : null,
        approve: this.viewTap,
        campaignid:
          this.filter.campaign && this.filter.campaign.id ? this.filter.campaign.id : null,
        typeid: this.filter.type ? this.filter.type : null,
        categoryname:
          this.filter.category && this.filter.category.categoryname
            ? this.filter.category.categoryname
            : null
      }
    }
  },
  async mounted() {
    await this.setupData()
  },
  methods: {
    statusCountSkillAll(status) {
      // let count =  this.countAllProductSkill && this.countAllProductSkill.find(el => el.approve === status).status_count
      // console.log("&&");
      
      // console.log(count);
      
      return (
        this.countAllProductSkill && this.countAllProductSkill.find(el => el.approve === status).status_count
      )
    },
    clickShowColumn(item) {
      if (this.showColumn.includes(item)) {
        var filterCheckbox = this.showColumn.filter(result => result !== item)
        this.showColumn = filterCheckbox
      } else {
        this.showColumn.push(item)
      }
    },
    clearSearchColumn() {
      this.searchColumn = ''
      this.column = this.columnAll
    },
    changeSearchColumn(name) {
      let outputResult
      if (name.target._value !== '') {
        outputResult = this.columnAll.filter(item => {
          return item.toLowerCase().indexOf(name.target._value.toLowerCase()) !== -1
        })
      } else {
        outputResult = this.columnAll.filter(item => {
          return item
        })
      }
      this.column = outputResult
    },
    customLabel(opt) {
      var type = this.typeList.find(x => {
        return x.typeid == opt
      })
      if (type) {
        return type.typename
      } else {
        return ''
      }
    },
    async clearSearch() {
      this.isSearch = false
      this.clearAdvancedSearch = false
      this.filter = {
        nameAll: '',
        campaign: null,
        type: null,
        category: null,
        techprovider: null
      }
      this.onSearch()
    },
    async onSearch() {
      this.loading = true
      this.isSearch = true
      this.page = 1
      await this.setupData()
      this.showSearchAdvanced = false
      this.loading = false
    },
    fullDateTime(input) {
      return moment(input).format('DD/MM/YYYY HH:mm')
    },
    async clickShowLog(id) {
      this.showLog = true
      this.loadLog = true
      let resData = await api.getproductApproveLog(id)
      this.loadLog = false
      if (resData) {
        this.logData = resData
      }
    },
    setupData() {
      this.getProductSkill()
      this.getCampaign()
      this.getCategory()
      this.getType()
      this.getCountAllProductSkill()
      
    },
    shotDate(input) {
      return input && moment(input).format('DD/MM/YYYY')
    },
    clickTap() {
      this.filterData(this.viewTap)
      this.clearSearch()
      this.isSearch = false
    },
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      await this.setupData()
      this.loading = false
    },
    async sortPage(pages) {
      let count = Math.ceil(this.total / this.rowsPerPage)
      if (pages == '' || Number(pages <= 0) || pages > Number(count)) return
      if (pages) {
        this.page = parseInt(pages)
        this.loading = true
        await this.setupData()
        this.loading = false
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    clickDetail(id) {
      window.open(`${config.techhuntUrl}product?id=${id}`)
    },
    updateTableHeader() {
      if (this.viewTap === 'pending') {
        this.headers = this.baseHeader
      } else if (this.viewTap === 'approve') {
        this.headers = this.fullHeader
      } else if (this.viewTap === 'reject') {
        this.headers = this.fullHeaderReject
      }
    },
    filterData(tap) {
      this.updateTableHeader()
      this.filter = {
        nameAll: '',
        campaign: null,
        type: null,
        category: null,
        techprovider: null,
        approve: tap
      }
      // let output = []
      // if (this.data) {
      //   this.data.forEach(ele => {
      //     if (ele.approve && ele.approve.toLowerCase() == tap) {
      //       output.push(ele)
      //     }
      //   })
      // }

      // this.fillStatusData = output
      // this.showData = output
    },
    async exportData() {
      this.loading = true
      await this.getExData()
      this.loading = false
      this.$refs.exbtn.exportxlsx()
    },
    async getExData() {
      try {
        let data = await api.getProductSkillReport({ where: this.body })
        
        await this.setEx(data.data)
      } catch (error) {
        console.error(error)
      }
    },
    async clickCheckBox() {
      let res = await api.updateProductSkillApprove(
        this.showData[this.modalID].productid,
        this.showData[this.modalID].approve === 'approve' ? 'pending' : 'approve'
      )
      if (res == 204) {
        this.modalApprove = false
        this.getProductSkill()
        this.getCountAllProductSkill()
        this.$swal.fire({
          type: 'success',
          title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
          text: `${moment(new Date()).format('DD/MM/YY') +
            ' ' +
            moment(new Date()).format('HH:mm')}`,
          confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
        })
      }
    },
    async clickRejectCheckBox() {
      let result = await this.$validator.validate()
      if (result) {
        let res = await api.updateProductSkillApprove(
          this.showData[this.modalID].productid,
          this.showData[this.modalID].approve === 'approve' ? 'reject' : 'reject',
          this.inputReject
        )
        if (res == 204) {
          this.modalReject = false
          this.getProductSkill()
          this.getCountAllProductSkill()
          this.$swal.fire({
            type: 'success',
            title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
            text: `${moment(new Date()).format('DD/MM/YY') +
              ' ' +
              moment(new Date()).format('HH:mm')}`,
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
          })
          this.inputReject = null
        }
      }
    },
    async clickUpdate(data){
      this.modalQualification = true
      let res = await api.getProductQualification(data)
      this.inputQualification = res[0].qualification
      this.productid = data
    },
    async updateQualification(id) {
      let result = await this.$validator.validate()      
      if (result) {        
        let res = await api.updateProductQualification(
          id,
          this.inputQualification
        )
        if (res == 200) {
          this.modalQualification = false
          this.$swal.fire({
            type: 'success',
            title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
            text: `${moment(new Date()).format('DD/MM/YY') +
              ' ' +
              moment(new Date()).format('HH:mm')}`,
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
          })
          this.inputQualification = null
        }
      }
    },
    async getCampaign() {
      this.campaign = await api.getCampaign()
    },
    async getCategory() {
      let categories = []
      var params = {
        typeid: this.filter.type ? this.filter.type : null
      }
      let data = await api.getCategory(params)
      data.data.map(item => {
        item.categories.map(items => {
          categories.push({ categoryid: items.categoryid, categoryname: items.categoryname })
        })
      })

      this.category = _.uniqBy(categories, 'categoryname')
    },
    async getType() {
      try {
        this.type = await api.getType()
        this.typeList = this.type.data
      } catch (error) {
        console.error(error)
      }
    },
    async getCountAllProductSkill() {
      try {
        let countAllProductSkill = await api.getCountAllProductSkill()
        this.countAllProductSkill = countAllProductSkill.data
        
      } catch (error) {
        console.error(error)
      }
    },
    async getProductSkill() {
      try {
        this.loading = true
        this.data = await api.getProductSkillReport({
          where: this.body,
          page: {
            quantity: this.rowsPerPage,
            page: this.page
          }
        })
        this.loading = false
        this.total = this.data.count
        this.data = this.data.data
        this.updateTableHeader()
        // let output = []
        // if (this.data) {
        //   this.data.forEach(ele => {
        //     if (ele.approve && ele.approve.toLowerCase() == this.viewTap) {
        //       output.push(ele)
        //     }
        //   })
        // }

        this.fillStatusData = this.data
        this.showData = this.data
        
        // this.filter = {
        //   campaign: null,
        //   type: null,
        //   category: null,
        //   techprovider: null,
        // }
      } catch (error) {
        console.error(error)
      }
    },
    setEx(data) {
      if (data) {
        let ex = []
        data.forEach(ele => {
          let obj = {
            'ผู้ขาย (Tech Provider)': ele.techprovidername,
            ชื่อหลักสูตร: ele.productname,
            ราคา: ele.price,
            รายละเอียด: ele.description,
            คะแนน: ele.score,
            ประเภท: ele.typename,
            หมวดหมู่: ele.categoryname,
            Copyright: ele.copyrighttype,
            Agent: ele.agent,
            สถานะ: ele.approve
          }
          ex.push(obj)
        })
        this.exData = ex
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fixTable table.v-table {
  thead {
    tr {
      th:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }

      th:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }

  tbody {
    tr {
      td:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        background: #ffffff;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }

      td:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/techhuntApprovedSkillbydepa/main.vue